import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ProjectConstants} from "../../../project-constants";
import {LocalCustomerFilterComponent} from "../../../general-components/filter/local-customer-filter/local-customer-filter.component";
import {ContractTypeFilterComponent} from "../../../general-components/filter/contract-type-filter/contract-type-filter.component";
import {NumAnnoMeseFilterComponent} from "../../../general-components/filter/num-anno-mese-filter/num-anno-mese-filter.component";
import {RegionFilterComponent} from "../../../general-components/filter/region-filter/region-filter.component";
import {AllSettingsFilterModel} from "../../../../models/AllSettingsFilterModel";
import {forkJoin, Observable, Subscription} from 'rxjs';
import {Offset} from "../../../../models/Offset";
import {ForecastVolumiModel} from "../../../../models/ForecastVolumiModel";
import {ResourceUnitFilterComponent} from "../../../general-components/filter/resource-unit-filter/resource-unit-filter.component";
import {NumAnnoMeseService} from "../../../general-services/service-num-anno-mese/num-anno-mese.service";
import {RegionService} from "../../../general-services/service-region-anagraf/region-service.service";
import {LocalCustomerAnagrafService} from "../../../general-services/service-local-customer-anagraf/local-customer-anagraf.service";
import {ContractTypeService} from "../../../general-services/service-contract-type/contract-type.service";
import {ResourceUnitService} from "../../../general-services/service-resources-units-anagraf/resource-unit.service";
import {ForecastVolumiService} from "../service-forecast-volumi/forecast-volumi.service";
import {LoaderService} from "../../../general-services/service-loader/loader.service";
import {Sl1AnagrafService} from '../../../general-services/service-sl1-services/sl1-anagraf.service';
import {MatDialog} from '@angular/material';
import {GenericArray} from '../../../../models/GenericArray';
import {DialogYearMonthComponent} from '../../../general-components/dialog-year-month/dialog-year-month.component';
import * as toastr from 'toastr';
import * as FileSaver from 'file-saver';
@Component({
  selector: 'app-filter-forecast-volumi',
  templateUrl: './filter-forecast-volumi.component.html',
  styleUrls: ['./filter-forecast-volumi.component.scss']
})
export class FilterForecastVolumiComponent extends ProjectConstants implements OnInit, OnDestroy {

  @Input() numAnnoMeseData?: any;
  @Input() filter?: ForecastVolumiModel;
  @Input() reportSection?: boolean;

  contractTypeData?: any;
  regionData: any;
  localCustomerData: any;
  resourceUnitData: any;

  @Output() dataFiltered = new EventEmitter<any>();
  @Output() resetDataFiltered = new EventEmitter<any>();

  @ViewChild(LocalCustomerFilterComponent) localCustomerFilterComponent;
  @ViewChild(ContractTypeFilterComponent) contractTypeFilterComponent;
  @ViewChild(NumAnnoMeseFilterComponent) numAnnoFilterComponent;
  @ViewChild(RegionFilterComponent) regionFilterComponent;
  @ViewChild(ResourceUnitFilterComponent) resourceUnitFilterComponent;

  filterSingle: AllSettingsFilterModel;
  labelAnnoMeseRif: string;
  getNameSubscribe: Subscription;
  downloadSubscribe: Subscription;
  offset: Offset;
  fileName: string;

  constructor(private loaderService: LoaderService,
              private forecastVolumiService: ForecastVolumiService,
              private numAnnoMeseService: NumAnnoMeseService,
              private regionService: RegionService,
              private localCustomerService: LocalCustomerAnagrafService,
              private contractTypeService: ContractTypeService,
              private resourceUnitService: ResourceUnitService,
              private dialog: MatDialog) {
    super();
    this.loaderService.display(true);
  }

  ngOnInit() {
    if (!this.filter) {
      this.filter = new ForecastVolumiModel();
    }
    this.filter.provider =  JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.filterSingle = AllSettingsFilterModel.getFromForecastVolumiModel(this.filter);

    this.offset = new Offset(10, 0);
    this.labelAnnoMeseRif = 'Reference Month';
    if (JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.FORECAST_VOLUMES_FILTER))) {
      this.filter = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.FORECAST_VOLUMES_FILTER));
    }

    this.initFilter(this.filterSingle);
  }

  initFilter(allSettingsFilterModel: AllSettingsFilterModel, isReset?: boolean) {
    const getAllRegionObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllLocalCustomerObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllContractTypeObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllResourceUnitObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      allSettingsFilterModel).pipe();

    forkJoin([getAllRegionObservable, getAllLocalCustomerObservable, getAllContractTypeObservable,
      getAllResourceUnitObservable])
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.contractTypeData = resultFork[2];
          this.resourceUnitData = resultFork[3];

          if (!isReset) {
            this.loaderService.display(false);
          } else {
            this.dataFiltered.emit(this.filter);
          }

        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptRegionChange(event) {
    this.loaderService.display(true);
    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.region = event;

    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();
    const getAllResourceUnitFilteredObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);
    observableList.push(getAllResourceUnitFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.localCustomerData = resultFork[0];
          this.contractTypeData = resultFork[1];
          this.resourceUnitData = resultFork[2];

          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.contractType = this.filterSingle.contractType;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptLocalCustomerChange(event) {
    this.loaderService.display(true);
    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.localCustomer = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();
    const getAllResourceUnitFilteredObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);
    observableList.push(getAllResourceUnitFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.contractTypeData = resultFork[1];
          this.resourceUnitData = resultFork[2];

          this.filter.region = this.filterSingle.region;
          this.filter.contractType = this.filterSingle.contractType;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptContractTypeChange(event) {
    this.loaderService.display(true);
    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.contractType = event;

    /** const getAllNumAnnoMeseFilteredObservable: Observable<any> = this.numAnnoMeseService.getAllMonth(
      this.filterSingle.contractType).pipe(); **/
    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllResourceUnitFilteredObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();

    // observableList.push(getAllNumAnnoMeseFilteredObservable);
    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllResourceUnitFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          // this.numAnnoMeseData = resultFork[0];
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.resourceUnitData = resultFork[2];

          this.filter.region = this.filterSingle.region;
          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptResourceUnitChange(event) {
    this.loaderService.display(true);
    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.resourceUnit = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.contractTypeData = resultFork[2];

          this.filter.region = this.filterSingle.region;
          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.contractType = this.filterSingle.contractType;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  filterTable(): void {
    this.loaderService.display(true);
    this.getAllFilters();
    if (!this.reportSection) {
      sessionStorage.setItem(this.SESSION_STORAGE_LABELS.FORECAST_VOLUMES_FILTER, JSON.stringify(this.filter));
    }
    this.dataFiltered.emit(this.filter);
  }

  reset() {
    this.loaderService.display(true);
    const isReset = true;
    this.filter = new ForecastVolumiModel();
    this.filter.provider =  JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.filterSingle = AllSettingsFilterModel.getFromForecastVolumiModel(this.filter);

    this.numAnnoMeseService.getAllMonth(this.filter.contractType).subscribe(
      (resultYearMonth: any) => {
        this.numAnnoMeseData = resultYearMonth;

        const numAnnoMese = resultYearMonth[0] ? resultYearMonth[0] : null;
        this.filter.numAnnoMese = numAnnoMese;

        sessionStorage.setItem(this.SESSION_STORAGE_LABELS.FORECAST_VOLUMES_FILTER, JSON.stringify(this.filter));
        this.filterSingle = AllSettingsFilterModel.getFromForecastVolumiModel(this.filter);

        this.initFilter(this.filterSingle, isReset);
      }, error => {
        console.log(error);
        this.loaderService.display(false);
    });

  }
  downloadTableCsv() {
    this.loaderService.display(true);
    this.getAllFilters();

    this.getNameSubscribe = this.forecastVolumiService.getNameGenerateCsv(this.offset, this.filter)
      .subscribe(
        resultPage => {
          this.fileName = resultPage.toString();
          this.downloadSubscribe = this.forecastVolumiService.getDownloadCsv(this.fileName)
            .subscribe( data => {
              toastr.success('CSV downloaded with success', 'Success');
              this.loaderService.display(false);
              FileSaver.saveAs(new Blob([data], { type: 'text/csv' }), this.fileName);
            });
        }, () => {
          toastr.error('Problem during download CSV, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }
  openDialogDownloadXlsx() {
    if (this.reportSection) {
      this.filterTable();
    }
    this.getAllFilters();

    const list: GenericArray[] = [
        {id: 'filter', value: this.filter},
        {id: 'offset', value: this.offset},
        {id: 'numAnnoMeseData', value: this.numAnnoMeseData},
        {id: 'serviceReportPage', value: this.SERVICE_REPORT_DOWNLOAD.FORECAST_VOLUMES}
      ],
      dialogRef = this.dialog.open(DialogYearMonthComponent, {
        data: {list}
      });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getAllFilters() {
    if (!this.reportSection) {
      this.filter.numAnnoMese = this.numAnnoFilterComponent.optionSelected;
    }    this.filter.region = this.regionFilterComponent.optionSelected;
    this.filter.localCustomer = this.localCustomerFilterComponent.optionSelected;
    this.filter.contractType = this.contractTypeFilterComponent.optionSelected;
    this.filter.resourceUnit = this.resourceUnitFilterComponent.optionSelected;
    this.loaderService.display(false);
  }

  ngOnDestroy(): void {
  }

}
